import { render, staticRenderFns } from "./PromoCodes.vue?vue&type=template&id=8ccf08de&scoped=true&"
import script from "./PromoCodes.vue?vue&type=script&lang=js&"
export * from "./PromoCodes.vue?vue&type=script&lang=js&"
import style0 from "./PromoCodes.vue?vue&type=style&index=0&id=8ccf08de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ccf08de",
  null
  
)

export default component.exports